module.exports = __webpack_public_path__ + "img/ch12.494a1775.jpg";